"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createField = _interopRequireDefault(require("./createField"));

var _plain = _interopRequireDefault(require("./structure/plain"));

var _default = (0, _createField["default"])(_plain["default"]);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/Field.js
// module id = 170
// module chunks = 0